import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { callApi, getInlineLoader, isAlphanumeric, resolveOrientation, formatMoney, callGameServerApi } from '../Helpers';
import { IoEnterOutline } from 'react-icons/io5';
import TopBar from '../components/TopBar';
import { AiFillDollarCircle, AiOutlineSetting, AiOutlineCheckCircle } from 'react-icons/ai';
import { MdOutlinePriceChange, MdOutlinePhonelinkRing, MdOutlineMarkEmailUnread, MdOutlineLogout } from 'react-icons/md';
import { RiLockPasswordLine } from 'react-icons/ri';
import { FaAward } from 'react-icons/fa';


export default function View(props) {
  const appContext = useContext(AppContext);
  const requiredOrientation = "portrait";

  const [ ready, setReady ] = useState(false);
  const [ loading, setLoading ] = useState(false);
  const [ email, setEmail ] = useState(appContext.userData.email);
  const [ step, setStep ] = useState('one');
  const [ otp, setOtp ] = useState('');

  const linkEmail = async () => {
    if(!loading) {
      if(email.trim().length > 0) {
        setLoading(true);
        await callGameServerApi('start-email-linkage', { email }).then(response => {
          setLoading(false)
          if(response.status === 1) {
            setStep('two');
            appContext.tellMessage('Verification code was sent to your email address, write it here')
          } else {
            appContext.tellError(response.msg);
          }
        })
      } else {
        appContext.tellError('Invalid email address');
      }
    }
  }

  const finalizeLink = async () => {
    if(!loading) {
      if(otp.trim().length > 0) {
        setLoading(true);
        await callGameServerApi('finish-email-linkage', { email, otp }).then(async response => {
          if(response.status === 1) {
            //update userData
            await appContext.getUserData();
            setLoading(false)
            setStep('one');
            appContext.tellMessage('Email was linked successfully')
          } else {
            setLoading(false)
            appContext.tellError(response.msg);
          }
        })
      } else {
        appContext.tellError('Invalid email verification code');
      }
    }
  }

  const init = async () => {
    appContext.changeOrientation(requiredOrientation);
    setReady(true);
  }

  useEffect(() => {
    if(appContext.auth) {
      //initialize
      init();
    } else {
      //take to common area
      appContext.openLogin();
    }
  }, []);

  useEffect(() => {
    if(ready) {
      appContext.setShowOverlayLoader(false);
    }
  }, [ ready ]);

  useEffect(() => {
    appContext.setShowOverlayLoader(loading);
  }, [ loading ]);

  if(ready) {
    return (
      <>
        <TopBar title="Link Email Address"/>
        <div className="FullPane"  data-support-top-bar={true}>
          <div className="container">
            <div className="row">

              <div className="col-md-6 col-sm-12" style={{ marginTop: "30px", paddingBottom: "30px" }}>
                {
                  (appContext.userData.email) ?
                  <>
                    <div className="text-center" style={{ marginBottom: "20px" }}>
                      <AiOutlineCheckCircle size={70} className="text-muted"/>
                    </div>
                    <h4 className="font-light">You've linked an email address.</h4>
                    <h6 className="font-light" style={{ marginTop: "30px" }}>{appContext.userData.email}</h6>
                    <small className="text-muted">You can also change it below</small>
                  </>
                  :
                  <>
                    <h4 className="font-light">You have not linked an Email Address</h4>
                    <small className="text-muted">Link your email address to receive alerts, awards and be able to recover your account easily</small>
                  </>
                }

                {
                  (step === "one") ?
                  <>
                    <hr/>
                    <div className="form-group" style={{ marginTop: "40px" }}>
                      <label>Email Address</label>
                      <input className="form-control" type="email" value={email} onChange={(e) => setEmail(e.target.value)}/>
                    </div>

                    <div className="text-end">
                      <button onClick={linkEmail} className="btn bg-goldish">
                      {
                        (appContext.userData.email) ?
                        "Change Email Address"
                        :
                        "Link Email Address"
                      }
                      </button>
                    </div>
                  </>: ""
                }

                {
                  (step === "two") ?
                  <>
                    <hr/>
                    <div className="form-group">
                      <label>Verification Code</label>
                      <input className="form-control" type="text" value={otp} onChange={(e) => setOtp(e.target.value)}/>
                      <small className="text-muted">Sent to {email}</small>
                    </div>

                    <div className="text-end">
                      <button onClick={finalizeLink} className="btn bg-goldish">Continue</button>
                    </div>
                  </>: ""
                }
              </div>

            </div>
          </div>
        </div>
      </>
    )
  } else {
    return (
      <div className="FullPane">
        {getInlineLoader()}
      </div>
    )
  }
}
